(function () {
  angular
    .module("akitabox.serviceRequest.newList")
    .controller(
      "NewServiceRequestListController",
      NewServiceRequestListController
    );

  /* @ngInject */
  function NewServiceRequestListController(
    // Angular
    $location,
    $scope,
    $state,
    // Services
    RequestService,
    OrganizationService,
    // Resolve
    query
  ) {
    var self = this;

    var filter = {};
    var baseQuery = {
      status: "new",
    };

    // Attributes
    self.organization = OrganizationService.getCurrent();
    self.requests = null;
    self.searchText = null;

    // Functions
    self.selectRequest = selectRequest;
    self.emptyList = emptyList;
    self.hasLoaded = hasLoaded;
    self.addServiceRequest = addServiceRequest;
    self.addWorkOrder = addWorkOrder;

    init();

    function init() {
      // Initialize search. Default to querystring
      self.searchText = query ? query : null;
      fetchRequests(self.searchText);
      self.searchOpen = !angular.isEmpty(self.searchText);
      // Watch search text
      $scope.$watch("vm.searchText", angular.debounce(onSearchTextChange, 500));
    }

    function addServiceRequest() {
      $state.go("app.serviceRequests.create");
    }

    function addWorkOrder() {
      $state.go("app.workOrders.create");
    }

    function onSearchTextChange(newValue, oldValue) {
      if (newValue !== oldValue) fetchRequests(newValue);
    }

    function updateFilter(params) {
      filter = angular.extend(filter, params);
    }

    function fetchRequests(text) {
      $location.search("q", text);
      updateFilter({ q: text });
      var params = angular.extend({}, baseQuery, filter);
      var queryParams =
        "_number=" +
        filter.q +
        ";subject=" +
        filter.q +
        ";description=" +
        filter.q;

      if (filter.q) {
        params.$or = queryParams;
        delete params.q;
      }

      self.requests = RequestService.getOrgVirtualRepeat(
        10,
        params,
        self.organization._id
      );
    }

    function hasLoaded() {
      if (self.requests) {
        return angular.isNumber(self.requests.numItems);
      }
      return false;
    }

    /**
     * Navigate to service request details
     *
     * @param {Object} request    The selected request
     */
    function selectRequest(request) {
      var buildingId = request.building._id
        ? request.building._id
        : request.building;
      $state.go("app.building.serviceRequest.detail", {
        buildingId: buildingId,
        requestId: request._id,
      });
    }

    function emptyList() {
      if (self.requests) {
        return self.requests.getLength() === 0;
      }
      return false;
    }
  }
})();
